import { DataSource, TreeSelectOption } from '@qfa/forms';
import {
  toSignalLocationOption,
  useIntersectionsLocationTreeDataSource,
} from './useIntersectionsLocationTreeDataSource';

export const useAlarmSignalLocationsTree = (): DataSource<TreeSelectOption[]> => {
  const dataSource = useIntersectionsLocationTreeDataSource({
    centerIds: 'all',
    groupsDisabled: false,
    toLocationOption: toSignalLocationOption,
  });
  return dataSource;
};
